import { Text, type TextProps } from '@mantine/core'
import { clsx } from 'clsx'
import { type PropsWithChildren } from 'react'

import classes from './styles.module.css'

export function PageDescription({
  children,
  className,
}: PropsWithChildren<TextProps>) {
  const classesDescription = clsx(classes.pageDescription, className)

  return (
    <Text className={classesDescription} color='dimmed'>
      {children}
    </Text>
  )
}

PageDescription.displayName = 'PageDescription'
